import { render, staticRenderFns } from "./JobsPositions.vue?vue&type=template&id=72ac5ab5"
import script from "./JobsPositions.vue?vue&type=script&lang=js"
export * from "./JobsPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports